import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import Child from "../../../../ui/template/Children/Child";
import AppConfig from "../../../Controllers/AppConfig";
import LikeInsert from "./LikeInsert";
import PropTypes from "prop-types";
import {digitsEnToFa} from "@persian-tools/persian-tools";

class   Likes  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.id=props.topicId;
        this.queryArgs = "topicId:"+this.id+",";

        this.routPost1="topicLike"+this.id;
        this.rowsId=0;
        this.HfunCV=this.funCV.bind(this);
        this.LikeInsertEl=React.createRef();
        this.psLike=null;
        this.props=props;
    }

    funCV(data,ts,recordKey,selectFun=null){

        let rows=[];
        let l=data.length;
        let s1="";
        for (let i=0;i<l;i++){
            this.rowsId++;
            s1='http://mdyaran.ir/membership/'+data[i].membershipId+'/picture';
            let el=   <img key={this.rowsId} src={s1}  alt=""   />   ;
            rows.push(el);
        }
        ts.cv=<> {rows} </>;

        if(ts.totalNumber>0){
            const d= digitsEnToFa(ts.totalNumber);
            this.psLike=<p>  {d} نفر دیگر لایک کردن </p>;
        }else{
            this.psLike=null;
        }
        this.LikeInsertEl.current.setNumberLikes(ts.totalNumber);
    }

    setNumberComments(num){
        this.LikeInsertEl.current.setNumberComments(num);
    }

   

    render() {

        return (
            <>
                <div className="p-3 border-bottom osahan-post-footer">
                    <LikeInsert ref={this.LikeInsertEl} topicId={this.props.topicId} />
                    <div className="likers-group">
                        <DataLoader ref={this.table1} scope="route" name={this.routPost1} classNameLoader="dataloader1"
                                    baseUrl={AppConfig.base_url} orderColumn={5} orderDir={2}  queryArgs={this.queryArgs}
                                    srcName="topicLike" getBoxItem={ this.HgetBoxItem} selectable={false}
                                    funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                                    queryFields="id,state,createdAt,usernameMember,membershipId">
                            <Child type="navbar">

                            </Child>
                            <Child type="links">

                            </Child>
                        </DataLoader>
                    </div>
                    <div className="likers-text">{this.psLike}  </div>
                </div>
            </>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Likes.contextType = MCbrowser;

Likes.propTypes = {
    topicId:PropTypes.string,
};

export default Likes;
